











import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
    name: 'section-title',
})
export default class SectionTitle extends Vue {
    @Prop({ type: String, required: false })
    icon!: string;
}
